import Button from "Components/Common/Button/Button";

interface TimeFilterProps {
  filters: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

export default function TimeFilter({
  filters,
  activeFilter,
  onFilterChange,
}: TimeFilterProps) {
  return (
    <div className="timeFilter" role="group" aria-label="Time filter">
      {filters.map((filter) => (
        <Button
          key={filter}
          type="button"
          className={`timeFilterBtn${activeFilter === filter ? " active" : ""}`}
          onClick={() => onFilterChange(filter)}
        >
          {filter}
        </Button>
      ))}
    </div>
  );
}
